import {ChangeRequest} from 'src/openapi/models/ChangeRequest';

type RoleLabel = 'Author' | 'Approver' | 'Reviewer';

export const getCommentRoleLabel = (
    userEmail: string,
    changeRequest: ChangeRequest | undefined,
): RoleLabel | null => {
    if (userEmail === changeRequest?.authorEmail) {
        return 'Author';
    }

    if (userEmail === changeRequest?.approverEmail) {
        return 'Approver';
    }

    if (userEmail === changeRequest?.reviewerEmail) {
        return 'Reviewer';
    }

    return null;
};
